<template>
    <div>
        <div class="score-elements-wrap pad-fix">
            <div class="element-menu">
                <div v-for="el in liveelements.elements" @click="$router.push(`/${compkey}/live/${$route.params.racid}/${el.id}`)" class="score-class" :key="el.id">
                    <span class="is-size-5"> {{el.name}} </span>
                    <span class="round-class-total"></span>
                </div>
            </div>
        </div>
        <footer class="score-footer is-size-5">
            <div class="score-footer-text  is-mobile ">
                
            </div>
        </footer>
    </div>
</template>

<script>
// TO DO: Add Nav that has classification in e.g. "Male - Open"
import { mapGetters } from 'vuex';
import moment from 'moment'
//import PTabs from '../../tabs/Tabs.vue'
//import PTabItem from '../../tabs/TabItem.vue'


export default {
    name: 'LiveElements',
    props: ['cid','acid', 'ceid', 'compname', 'compkey'],
    data() {
        return {
            ready: false
        }
    },
    mounted() {
        if(this.liveelements && this.liveelements.racId != this.$attrs.racid)
            this.ready = false
        if(!this.liveelements)
            this.ready = false
        this.$store.dispatch('scoring/get_live_elements', { key: this.$route.params.key, racid:this.$route.params.racid})
        .then(() => {
            console.log('Got live els')
            this.$store.dispatch('scoring/set_prev_route', {round: this.liveelements.roundLabel, class:this.liveelements.classLabel, age: this.liveelements.ageLabel})
            this.ready = true
        })
    },
    computed: {
        ...mapGetters({ liveelements: 'scoring/liveelements'}),
    },
    methods: {
        format(str) {
            return moment(str).format('ddd Do MMM')
        },
        time(str) {
            return moment(str).format('HH:mm')
        },
    }
}
</script>

<style>
.live-mini-nav {
    position: fixed;
    width: 100%;
    top: 3.5rem;
    margin-top: -1px;
    display: flex; 
    align-items: stretch;
    justify-content: center;
    padding: 0.5rem 0;
    border-bottom: 1px solid #999;
    background-color: #fff;
}
.live-mini-nav span { padding: 0 0.75rem; }
.live-mini-round {  border-right: 1px solid #ddd; }
.live-mini-nav span { white-space: nowrap; }
.live-mini-class {  flex-grow: 1; }
</style>